export default __webpack_public_path__ + "9ec23849b2a29e00d138fe2b15155267.svg";